/**
 * @param {Observable<Playback & Config & ResumePoints & Asset>} playerLoad$
 * @param {playback-web-player.PlayerFacade} player
 * @returns {Subscription}
 */

const subscribeToManifestLoadStream = (
    loadData$,
    player
) =>
    loadData$
        .subscribe(({
            mediaType,
            licenseUrl,
            releasePid,
            manifestUrl,
            authToken,
            tileImageUrl,
            resumeFrom,
            title,
            convivaCustomMetaData,
            viewerId,
            enableClosedCaptions,
        }) => {
            player.load({
                src: manifestUrl,
                mediaType,
                isEncrypted: true,
                startTime: resumeFrom,
                posterUrl: tileImageUrl,
                title,
                convivaCustomMetaData,
            });
            player.configure({
                drm: {
                    authToken,
                    licenseUrl,
                    releasePid,
                },
                analytics: {
                    viewerId,
                },
                watermark: {
                    content: viewerId,
                },
                captions: {
                    enable: enableClosedCaptions,
                },
            });
        });

export default subscribeToManifestLoadStream;
